export default __webpack_public_path__ + "static/media/gps2.8de35537.svg";